"use client";

import Image from "next/image";
import { HeaderV2 } from "../../sections/HeaderV2/HeaderV2";
import type { HeaderV2Props } from "../../sections/HeaderV2/types";
import type { Unit } from "../../components/UnitsSelector/UnitsSelector";
import { useGlobalQueryParams } from "../../hooks/queryParams/useGlobalQueryParams";

type ImageProps = { src: string; alt: string; width?: number; height?: number; className?: string };

interface HeaderV2WrapperProps extends HeaderV2Props<ImageProps> {
  units?: Unit[];
}

export default (props: HeaderV2WrapperProps) => {
  const newProps = {
    ...props,
    image: {
      props: props.image?.props || { src: "", alt: "" },
      redirect: props.image?.redirect,
      render: (imageProps: ImageProps) => <Image {...imageProps} width={150} height={32} priority={props.preload !== false} />,
    },
    image2: props.image2
      ? {
          ...props.image2,
          redirect: props.image2?.redirect,
          render: (imageProps: ImageProps) => <Image {...imageProps} width={150} height={32} priority={props.preload !== false} />,
        }
      : undefined,
    imageScrolled: props.imageScrolled
      ? {
          ...props.imageScrolled,
          redirect: props.imageScrolled?.redirect,
          render: (imageProps: ImageProps) => <Image {...imageProps} width={150} height={32} />,
        }
      : undefined,
    image2Scrolled: props.image2Scrolled
      ? {
          ...props.image2Scrolled,
          redirect: props.image2Scrolled?.redirect,
          render: (imageProps: ImageProps) => <Image {...imageProps} width={150} height={32} />,
        }
      : undefined,
  };

  return <HeaderV2 {...newProps} useGlobalQueryParams={useGlobalQueryParams} />;
};
